import { useLocation } from "react-router-dom";
import queryString from 'query-string';


const useUrlNavigation = () => {
    const location = useLocation();


    const qsToUrl = (query) => {
        const qsUrl = queryString.parse(location.search);
        const qsString = queryString.parse("?" + query);

        Object.keys(qsString)?.map((key) => 
            delete qsUrl[key]
        )
        
        let qsToUrl = new URLSearchParams(qsUrl).toString();
        qsToUrl = "?" + ((qsToUrl !== "")? qsToUrl + "&" : "");

        return qsToUrl;
    }



    const getUrlQueries = () => {
        const qsUrl = queryString.parse(location.search);
        return qsUrl;
    }


    const removeUrlQuery = (params) => {
        const qsUrl = queryString.parse(location.search);
        Object.keys(qsUrl)?.map((key) => {
            for (let i = 0; i < params.length; i++){
                if (key === params[i]){
                    delete qsUrl[key]
                }
            }
            return null;
        })
        let qsToUrl = new URLSearchParams(qsUrl).toString();
        return ("?" + qsToUrl);
    }


    /**
     * usage
     * urlQuery("key1=value1&key2=value2")
     * */
    const urlQuery = (query) => {
        return (qsToUrl(query) + query);
    }


    return {
        qsToUrl,
        getUrlQueries,
        removeUrlQuery,
        urlQuery
    };
}


export default useUrlNavigation;
